import type { Placement } from '@floating-ui/react';

const getPlacement = (position: Position, alignment: Alignment): Placement =>
  [position, alignment]
    .map(value => (value === 'middle' ? '' : value))
    .filter(value => Boolean(value))
    .join('-') as Placement;

const getOffset = (
  offset: { x: number; y: number } | undefined,
  position: Position
): { mainAxis?: number; crossAxis?: number } => {
  const options: { mainAxis?: number; crossAxis?: number } = {};
  if (offset) {
    const { x, y } = offset;
    options.mainAxis = ['right', 'left'].includes(position) ? x : y;
    options.crossAxis = ['top', 'bottom'].includes(position) ? x : y;
  }
  return options;
};

export { getPlacement, getOffset };
